import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import CanvasserSection from './CanvasserSection';
import UnassignedSection from './UnassignedSection';
import { useDoorCrewCard } from './DoorCrewCardContext';
import { getSeatTurfId } from './groupSeatsByTurf';
import { DoorCrewSeat } from './types';

interface CanvasserSeatRowProps {
  seat: DoorCrewSeat;
  seatNumber: number;
}

export default function CanvasserSeatRow({ seat, seatNumber }: CanvasserSeatRowProps) {
  const { onDeleteSeat } = useDoorCrewCard();
  const turfId = getSeatTurfId(seat);

  const handleDeleteSeat = () => {
    onDeleteSeat(seat.id, turfId ?? undefined, seat.canvasser);
  };

  return (
    <div className="canvasser-seat-row">
      <span className="seat-number-badge">Seat {seatNumber}</span>

      <Droppable droppableId={'turf-assign_seat_' + seat.id} type="CANVASSER">
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={`seat-card-body${snapshot.isDraggingOver ? ' dragging-over' : ''}`}
          >
            {seat.canvasser ? (
              <CanvasserSection
                canvasserId={seat.canvasser}
                seat={seat}
                onDeleteSeat={handleDeleteSeat}
              />
            ) : (
              <UnassignedSection seat={seat} onDeleteSeat={handleDeleteSeat} />
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
}
